import * as Sentry from '@sentry/react';

import deleteJSON from 'utilities/deleteJSON';
import { API_BASE_URL } from 'utilities/env';
import getJSON from 'utilities/getJSON';
import postJSON from 'utilities/postJSON';

import { getLeadId } from 'temp/utilities/apiSession/leadId';

const getUrl = () => {
    const leadId = getLeadId();
    return `${API_BASE_URL}/Lead/${leadId}/Provider`;
};

const getProvidersSearchLookUp = async () => {
    const url = getUrl() + '/ProviderSearchLookup';
    try {
        return await getJSON({ url });
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};

const addProvider = async ({ addressId, isPrimary, npi }) => {
    const body = [{ addressId, isPrimary, npi }];
    const url = getUrl();
    try {
        return await postJSON({ url, body });
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};

const deleteProvider = async ({ addressId, npi }) => {
    const url = `${getUrl()}/${npi}?addressId=${addressId}`;
    try {
        return await deleteJSON({ url });
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};

const getProviders = async () => {
    try {
        return await getJSON({ url: getUrl() });
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};

export { addProvider, deleteProvider, getProviders, getProvidersSearchLookUp };
